<template>
  <!-- 公司管理 -->
  <div class="container_cm">
    <div class="main_cm">
      <div class="bh_cm">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/guidance' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item>公司管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="top_cm">
        <el-form :inline="true" class="demo-form-inline" size="small">
          <el-form-item label="公司/部门名称">
            <el-input  maxlength="100" v-model="name" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
        <div>
          <el-button class="mybtny" v-waves icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
          <el-button class="mybtny" v-waves icon="el-icon-edit" @click="addProject">新建</el-button>
        </div>
      </div>
      <div class="table_cm">
        <el-table :data="List" row-key="deptId"  element-loading-background="rgba(0, 0, 0, 0.1)"
          v-loading="loading" :tree-props="{ children: 'child', hasChildren: 'hasChildren' }" style="width: 100%">
          <el-table-column prop="name" label="公司/部门" align="left">
          </el-table-column>
          <el-table-column prop="path" label="公司简称" align="left">
          </el-table-column>
          <el-table-column prop="openDeliver" label="线下交接状态" align="center">
            <template slot-scope="scope">
              <div :class="['icon_bg', 'iconfont', scope.row.openDeliver == false ? 'icon-x' : 'icon-dagou-icon']"></div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click.native.prevent="editClick(scope.row)">编辑</el-button>
              <el-button type="text" @click.native.prevent="stop(scope.row)">{{ scope.row.delFlag==1?'启用':'停用' }}</el-button>
              <el-button type="text" v-if="scope.row.rank<=2"  @click.native.prevent="addProject(scope.row)">添加</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="el-pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
          :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
        </div>

      </div>
    </div>
    <!-- 新建公司 -->
    <div>
      <el-dialog title="新建公司/部门" center :visible.sync="addVisible" width="700px" v-if="addVisible"
        :close-on-click-modal="false">
        <add-model :deptId="deptId" @cancel="cancel" @submit="submit"></add-model>
      </el-dialog>
    </div>
    <!-- 编辑公司 -->
    <div>
      <el-dialog title="编辑公司/部门" center :visible.sync="editVisible" width="700px" v-if="editVisible"
        :close-on-click-modal="false">
        <edit-model @cancel="cancelEdit" @submit="submit" :editData='editData'></edit-model>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getCompanyInfo, addCompany, updateCompany, delCompany,enableDept } from "@/api/systemApi.js";
import addModel from "./components/addModel";
import editModel from "./components/editModel";
import Table from "@/components/myTable";
export default {
  inject: ['reload'],
  components: {
    addModel,
    editModel,
    Table,
  },
  data() {
    return {
      name: null,
      deptId: null,
      userInfo: '',
      List: [],
      cloumns: [],
      loading: false,
      pageIndex: 1, //默认当前页
      pageSize: 10, //每页显示数量
      total: 0, //总条数
      searchForm: {},
      addVisible: false, //新增项目弹窗
      editVisible: false, //编辑项目弹窗
      editData: '', //待编辑项目数据
    }
  },
  created() {

  },
  mounted() {
    this.getInfo();
  },
  methods: {
    handleSizeChange(page) {
      this.currentPage = 1;
      this.pageSize = page;
      this.getInfo();
    },
    // 获取公司信息
    getInfo() {
      let params = {
        name:this.name,
        current: this.pageIndex,
        size: this.pageSize,
      };
      this.loading = true;
      getCompanyInfo(params).then(res => {
        if (res.code == "200") {
          this.List = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg || "服务器连接失败");
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        this.$message.error(err.msg || err.message || "服务器连接失败");
      });
    },
    toSearch() {
      this.pageIndex = 1;
      this.getInfo();
    },
    reset() {

    },
    // 点击页码操作
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getInfo();
    },
    // 刷新
    refresh() {
      this.reload();
    },
    // 新增
    addProject(data) {
      this.deptId = data.deptId || null
      this.addVisible = true;
    },
    // 编辑
    editClick(row) {
      this.editData = JSON.parse(JSON.stringify(row))
      this.editVisible = true;
    },
    // 新增/编辑项目提交
    submit(data, isAdd) {
      if (isAdd) {
        let params = {
          ...data
        }
        console.log(params)
        addCompany(params).then(res => {
          if (res.code == '200') {
            this.$message.success(res.msg || '新增成功！');
            this.cancel();
            this.getInfo();
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        updateCompany({ ...data }).then(res => {
          if (res.code == '200') {
            this.$message.success(res.msg || "修改成功！");
            this.cancelEdit();
            this.getInfo();
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    // 新增取消
    cancel() {
      this.addVisible = false;
    },
    // 编辑取消
    cancelEdit() {
      this.editVisible = false;
    },
    // 停用
   async stop(row) {
      let _this = this;
      _this.$confirm(`确定${row.delFlag==1?'启用':'停用'}该公司吗?`, '停用提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then( async () => {
        const res =row.delFlag==1? await enableDept(row.deptId) : await delCompany(row.deptId)
        const { code,msg} = res
        if(code!=200){
          _this.$message.error(msg)
          return
        }
        _this.getInfo();
      })
    }
  }
  
}
</script>

<style lang="less" scoped>
.container_cm {
  width: 100%;
  height: calc(100% - 30px);
  padding: 15px 0;

  .main_cm {
    height: calc(100% - 82px);
    margin: 0 auto;

    .bh_cm {
      height: 20px;
      line-height: 20px;
    }

    .top_cm {
      margin: 10px 0;
      display: flex;
      justify-content: space-between;

      .el-input {
        width: 200px;
        margin: 0 20px;
      }

      .el-button {
        width: 140px;
        margin-left: 20px;
      }

      .el-select {
        margin: 0 20px;
      }
    }

    .table_cm {
      height: 100%;

      .el-button {
        width: 50px;
        height: 30px;
        padding: 0;
      }
    }
  }
}
.el-pagination{
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/sysmanage/Companymanage/index.vue